import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ProblemForUserState } from './state';
import * as selectors from './selectors';
import * as actions from './actions';
import { UserFacade } from '../user/facade';

@Injectable()
export class ProblemForUserFacade {
  private store = inject<Store<ProblemForUserState>>(Store);
  private userFacade = inject(UserFacade);

  allProblems$ = this.store.pipe(select(selectors.selectAll));

  constructor() {
    this.userFacade.selected().subscribe(user => {
      if (user) {
        this.loadProblems(user.id);
      }
    });
  }

  loadProblems(userId: number) {
    this.store.dispatch(new actions.LoadRequestAction(userId));
  }

  subscriptionProblem(problemId: number, userId: number) {
    this.store.dispatch(new actions.CreateSubscriptionRequestAction(problemId, userId));
  }

  unSubscriptionProblem(subscription: number) {
    this.store.dispatch(new actions.DeleteSubscriptionRequestAction(subscription));
  }

  lockProblem(problemId: number, userId: number) {
    this.store.dispatch(new actions.CreateLockRequestAction(problemId, userId));
  }

  getError(): Observable<any> {
    return this.store.pipe(select(selectors.selectError));
  }

  isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.selectIsLoading));
  }
}
